/**
 * 为了解决循环依赖的问题，只能把HttpService的实例化过程提取出来，单独放到一个文件中。
 * 还有一点也是为了api的定义方式采用了函数式定义，而不是类的形式定义。
 * 如果是类的形式来定义api，那么就可以和service一样采用依赖注入的方式来解决循环依赖。
 * 不过权衡利弊之后还是觉得函数式定义在使用方面更方便。
 */
import { useRootService } from '@kaokei/use-vue-service';
import { HttpService } from '@core/services/http.service';

// eslint-disable-next-line import/no-mutable-exports
export let httpService!: HttpService;

export function init() {
  httpService = useRootService(HttpService);
}
